module.exports = __webpack_public_path__ + "B.svg?f68809d4f072d976ad534a80c40ab3cd";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/symbols/B.svg
// module id = 52
// module chunks = 0